import { PlausibleTracker } from './trackers/PlausibleTracker';
import { GtagTracker } from './trackers/GtagTracker';
import { Tracker, TrackingEvent, TrackerLogger } from './Tracking.events';

export class Trackers implements Tracker {
	gtag: Tracker | null = null;
	gtm: Tracker | null = null;
	matomo: Tracker | null = null;
	plausible: Tracker | null = null;

	constructor(args: TrackersArgs) {
		const { gtag, plausible } = args;
		if (gtag) {
			this.gtag = new GtagTracker();
		}

		if (plausible) {
			this.plausible = new PlausibleTracker(plausible);
		}
	}
	sendEvent(event: TrackingEvent) {
		TrackerLogger.debug(`Event:`, event);
		if (this.gtag) {
			this.gtag.sendEvent(event);
		}
		if (this.gtm) {
			this.gtm.sendEvent(event);
		}
		if (this.matomo) {
			this.matomo.sendEvent(event);
		}
		if (this.plausible) {
			this.plausible.sendEvent(event);
		}
	}
}

interface TrackersArgs {
	gtag?: any;
	gtm?: any;
	matomo?: any;
	plausible?: any;
}
